/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import axios from "axios";
import Cookies from "universal-cookie";
import Config from "../../config/index";
import {
  ADD_ATTACHMENTS_FAILURE,
  ADD_ATTACHMENTS_REQUEST,
  ADD_ATTACHMENTS_SUCCESS,
  ADD_TICKET_COMMENTS_FAILURE,
  ADD_TICKET_COMMENTS_REQUEST,
  ADD_TICKET_COMMENTS_SUCCESS,
  CLOSE_INPROGRESS_FAILURE,
  CLOSE_INPROGRESS_REQUEST,
  CLOSE_INPROGRESS_SUCCESS,
  CREATE_REPORT_TICKET_FAILURE,
  CREATE_REPORT_TICKET_REQUEST,
  CREATE_REPORT_TICKET_SUCCESS,
  DELETE_INPROGRESS_FAILURE,
  DELETE_INPROGRESS_REQUEST,
  DELETE_INPROGRESS_SUCCESS,
  GET_COMPLETED_TICKETS_FAILURE,
  GET_COMPLETED_TICKETS_REQUEST,
  GET_COMPLETED_TICKETS_SUCCESS,
  GET_REPORTED_TICKETS_FAILURE,
  GET_REPORTED_TICKETS_REQUEST,
  GET_REPORTED_TICKETS_SUCCESS,
  GET_REQUESTTYPES_FAILURE,
  GET_REQUESTTYPES_REQUEST,
  GET_REQUESTTYPES_SUCCESS,
  GET_STATUS_INPROGRESS_FAILURE,
  GET_STATUS_INPROGRESS_REQUEST,
  GET_STATUS_INPROGRESS_SUCCESS,
  GET_TICKETS_COUNTS_FAILURE,
  GET_TICKETS_COUNTS_FOR_ACTIVE_FAILURE,
  GET_TICKETS_COUNTS_FOR_ACTIVE_REQUEST,
  GET_TICKETS_COUNTS_FOR_ACTIVE_SUCCESS,
  GET_TICKETS_COUNTS_REQUEST,
  GET_TICKETS_COUNTS_SUCCESS,
  GET_TICKET_COMMENTS_FAILURE,
  GET_TICKET_COMMENTS_REQUEST,
  GET_TICKET_COMMENTS_SUCCESS,
  GET_TICKET_DETAILS_FAILURE,
  GET_TICKET_DETAILS_REQUEST,
  GET_TICKET_DETAILS_SUCCESS,
  GET_TICKET_STATUS_FAILURE,
  GET_TICKET_STATUS_REQUEST,
  GET_TICKET_STATUS_SUCCESS,
  RE_OPEN_TICKET_FAILURE,
  RE_OPEN_TICKET_REQUEST,
  RE_OPEN_TICKET_SUCCESS,
  TICKET_HOMEPAGE_FAILURE,
  TICKET_HOMEPAGE_REQUEST,
  TICKET_HOMEPAGE_SUCCESS,
  UPDATE_INPROGRESS_FAILURE,
  UPDATE_INPROGRESS_REQUEST,
  UPDATE_INPROGRESS_SUCCESS,
} from "./ticketsTypes";
let baseUrl = Config.baseUrl;
let serviceDeskId = Config.serviceDeskId;

const cookies = new Cookies();
const userData = cookies.get("loginDetailsForSupport");

const getReportedTicketsRequest = () => {
  return {
    type: GET_REPORTED_TICKETS_REQUEST,
  };
};

const getReportedTicketsSuccess = (payload) => {
  return {
    type: GET_REPORTED_TICKETS_SUCCESS,
    payload: payload,
  };
};

const getReportedTicketsFaliure = (error) => {
  return {
    type: GET_REPORTED_TICKETS_FAILURE,
    payload: error,
  };
};

const getReportedTickets = (token) => {
  return (dispatch) => {
    dispatch(getReportedTicketsRequest());
    let url = `${baseUrl}/sp/ticket/get_ticket?statusId=0`;
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .get(url, config)
      .then((response) => {
        dispatch(getReportedTicketsSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(getReportedTicketsFaliure(err.message));
        return { status: false, message: err.message };
      });
  };
};

const createTicketRequest = () => {
  return {
    type: CREATE_REPORT_TICKET_REQUEST,
  };
};

const createTicketSuccess = (payload) => {
  return {
    type: CREATE_REPORT_TICKET_SUCCESS,
    payload: payload,
  };
};

const createTicketFaliure = (error) => {
  return {
    type: CREATE_REPORT_TICKET_FAILURE,
    payload: error,
  };
};

const createTicket = (payload, token) => {
  return (dispatch) => {
    dispatch(createTicketRequest());
    let url = `${baseUrl}/sp/ticket/create_ticket`;
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    return axios
      .post(url, payload, config)
      .then((response) => {
        dispatch(createTicketSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createTicketFaliure(err.message));
        return { status: false, message: err.message };
      });
  };
};

const addAttachmentsRequest = () => {
  return {
    type: ADD_ATTACHMENTS_REQUEST,
  };
};

const addAttachmentsSuccess = (payload) => {
  return {
    type: ADD_ATTACHMENTS_SUCCESS,
    payload: payload,
  };
};

const addAttachmentsFaliure = (error) => {
  return {
    type: ADD_ATTACHMENTS_FAILURE,
    payload: error,
  };
};

const addAttachments = (payload, token) => {
  return (dispatch) => {
    dispatch(addAttachmentsRequest());
    let url = `${baseUrl}/jira/requests/add_attachments`;
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    return axios
      .post(url, payload, config)
      .then((response) => {
        dispatch(addAttachmentsSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(addAttachmentsFaliure(err.message));
        return { status: false, message: err.message };
      });
  };
};

const getRequestTypesRequest = () => {
  return {
    type: GET_REQUESTTYPES_REQUEST,
  };
};

const getRequestTypesSuccess = (payload) => {
  return {
    type: GET_REQUESTTYPES_SUCCESS,
    payload: payload,
  };
};

const getRequestTypesFaliure = (error) => {
  return {
    type: GET_REQUESTTYPES_FAILURE,
    payload: error,
  };
};

const getRequestTypes = (token) => {
  return (dispatch) => {
    dispatch(getRequestTypesRequest());
    let url = `${baseUrl}/jira/requests/requesttypes?desk_id=${serviceDeskId}`;
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .get(url, config)
      .then((response) => {
        dispatch(getRequestTypesSuccess(response.data.data));
      })
      .catch((err) => {
        dispatch(getRequestTypesFaliure(err.message));
      });
  };
};

const ticketHomePageRequest = () => {
  return {
    type: TICKET_HOMEPAGE_REQUEST,
  };
};

const ticketHomePageSuccess = (payload) => {
  return {
    type: TICKET_HOMEPAGE_SUCCESS,
    payload: payload,
  };
};

const ticketHomePageFaliure = (error) => {
  return {
    type: TICKET_HOMEPAGE_FAILURE,
    payload: error,
  };
};

const ticketHomePage = (payload, token) => {
  return (dispatch) => {
    dispatch(ticketHomePageRequest());
    let url = `${baseUrl}/jira/requests/requests_count`;
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .post(url, payload, config)
      .then((response) => {
        dispatch(ticketHomePageSuccess(response.data));
      })
      .catch((err) => {
        dispatch(ticketHomePageFaliure(err.message));
      });
  };
};

const getTicketStatusRequest = () => {
  return {
    type: GET_TICKET_STATUS_REQUEST,
  };
};

const getTicketStatusSuccess = (payload) => {
  return {
    type: GET_TICKET_STATUS_SUCCESS,
    payload: payload,
  };
};

const getTicketStatusFaliure = (error) => {
  return {
    type: GET_TICKET_STATUS_FAILURE,
    payload: error,
  };
};
const getTicketStatus = (id, token) => {
  return (dispatch) => {
    dispatch(getTicketStatusRequest());
    let url = `${baseUrl}/jira/requests/request_by_id?issue_id=${id}`;
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .get(url, config)
      .then((response) => {
        dispatch(getTicketStatusSuccess(response.data.data));
      })
      .catch((err) => {
        dispatch(getTicketStatusFaliure(err.message));
      });
  };
};

const getCompletedTicketsRequest = () => {
  return {
    type: GET_COMPLETED_TICKETS_REQUEST,
  };
};

const getCompletedTicketsSuccess = (payload) => {
  return {
    type: GET_COMPLETED_TICKETS_SUCCESS,
    payload: payload,
  };
};

const getCompletedTicketsFaliure = (error) => {
  return {
    type: GET_COMPLETED_TICKETS_FAILURE,
    payload: error,
  };
};

// const getCompletedTickets = ( token) => {
//   return (dispatch) => {
//     dispatch(getCompletedTicketsRequest());
//     let url = `${baseUrl}/sp/ticket/get_ticket?statusId=1`;
//     let config = {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     };
//     axios
//       .get(url, config)
//       .then((response) => {
//         console.log("response",response)
//         dispatch(getCompletedTicketsSuccess(response.data));
//       })
//       .catch((err) => {
//         dispatch(getCompletedTicketsFaliure(err.message));
//       });
//   };
// };
const getCompletedTickets = (token) => {
  return (dispatch) => {
    dispatch(getCompletedTicketsRequest());
    let url = `${baseUrl}/sp/ticket/get_ticket?statusId=1`;
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .get(url, config)
      .then((response) => {
        dispatch(getCompletedTicketsSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(getCompletedTicketsFaliure(err.message));
        return { status: false, message: err.message };
      });
  };
};

const getTicketCommentsRequest = () => {
  return {
    type: GET_TICKET_COMMENTS_REQUEST,
  };
};

const getTicketCommentsSuccess = (payload) => {
  return {
    type: GET_TICKET_COMMENTS_SUCCESS,
    payload: payload,
  };
};

const getTicketCommentsFaliure = (error) => {
  return {
    type: GET_TICKET_COMMENTS_FAILURE,
    payload: error,
  };
};

const getTicketComments = (id, email, token) => {
  return (dispatch) => {
    dispatch(getTicketCommentsRequest());
    let url = `${baseUrl}/jira/requests/comments?issue_id=${id}&email=${email}`;
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .get(url, config)
      .then((response) => {
        dispatch(getTicketCommentsSuccess(response.data.data));
      })
      .catch((err) => {
        dispatch(getTicketCommentsFaliure(err.message));
      });
  };
};

const addTicketCommentRequest = () => {
  return {
    type: ADD_TICKET_COMMENTS_REQUEST,
  };
};

const addTicketCommentSuccess = (payload) => {
  return {
    type: ADD_TICKET_COMMENTS_SUCCESS,
    payload: payload,
  };
};

const addTicketCommentFaliure = (error) => {
  return {
    type: ADD_TICKET_COMMENTS_FAILURE,
    payload: error,
  };
};

const addTicketComment = (payload, token) => {
  return (dispatch) => {
    dispatch(addTicketCommentRequest());
    let url = `${baseUrl}/jira/requests/add_comment`;
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    return axios
      .post(url, payload, config)
      .then((response) => {
        dispatch(addTicketCommentSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(addTicketCommentFaliure(err.message));
        return { status: false, message: err.message };
      });
  };
};

const reopenTicketRequest = () => {
  return {
    type: RE_OPEN_TICKET_REQUEST,
  };
};

const reopenTicketSuccess = (payload) => {
  return {
    type: RE_OPEN_TICKET_SUCCESS,
    payload: payload,
  };
};

const reopenTicketFailure = (error) => {
  return {
    type: RE_OPEN_TICKET_FAILURE,
    payload: error,
  };
};

const reopenTicket = (payload, token) => {
  return (dispatch) => {
    dispatch(reopenTicketRequest());
    let url = `${baseUrl}/jira/requests/reopen_ticket`;
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    return axios
      .put(url, payload, config)
      .then((response) => {
        dispatch(reopenTicketSuccess(response));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(reopenTicketFailure(err.message));
        return { status: false, message: err.message };
      });
  };
};

const getTicketsByStatusForCompletedRequest = () => {
  return {
    type: GET_TICKETS_COUNTS_REQUEST,
  };
};

const getTicketsByStatusForCompletedSuccess = (payload) => {
  return {
    type: GET_TICKETS_COUNTS_SUCCESS,
    payload: payload,
  };
};

const getTicketsByStatusForCompletedFaliure = (error) => {
  return {
    type: GET_TICKETS_COUNTS_FAILURE,
    payload: error,
  };
};

const getTicketsByStatusForCompleted = (token) => {
  return (dispatch) => {
    dispatch(getTicketsByStatusForCompletedRequest());
    let url = `${baseUrl}/jira/requests/get_issue_count?status=Completed`;
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .get(url, config)
      .then((response) => {
        dispatch(getTicketsByStatusForCompletedSuccess(response.data.data));
      })
      .catch((err) => {
        dispatch(getTicketsByStatusForCompletedFaliure(err.message));
      });
  };
};

const getTicketsByStatusForActiveRequest = () => {
  return {
    type: GET_TICKETS_COUNTS_FOR_ACTIVE_REQUEST,
  };
};

const getTicketsByStatusForActiveSuccess = (payload) => {
  return {
    type: GET_TICKETS_COUNTS_FOR_ACTIVE_SUCCESS,
    payload: payload,
  };
};

const getTicketsByStatusForActiveFaliure = (error) => {
  return {
    type: GET_TICKETS_COUNTS_FOR_ACTIVE_FAILURE,
    payload: error,
  };
};

const getTicketsByStatusForActive = (token) => {
  return (dispatch) => {
    dispatch(getTicketsByStatusForActiveRequest());
    let url = `${baseUrl}/jira/requests/get_issue_count?status=Active`;
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .get(url, config)
      .then((response) => {
        dispatch(getTicketsByStatusForActiveSuccess(response.data.data));
      })
      .catch((err) => {
        dispatch(getTicketsByStatusForActiveFaliure(err.message));
      });
  };
};

const getHomeTicketDetailsRequest = () => {
  return {
    type: GET_TICKET_DETAILS_REQUEST,
  };
};

const getHomeTicketDetailsSuccess = (payload) => {
  return {
    type: GET_TICKET_DETAILS_SUCCESS,
    payload: payload,
  };
};

const getHomeTicketDetailsFaliure = (error) => {
  return {
    type: GET_TICKET_DETAILS_FAILURE,
    payload: error,
  };
};

const getHomeTicketDetails = (clientId, token) => {
  return (dispatch) => {
    dispatch(getHomeTicketDetailsRequest());
    let url = `${baseUrl}/jira/requests/get_issue_count?clientId=${clientId}`;
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .get(url, config)
      .then((response) => {
        dispatch(getHomeTicketDetailsSuccess(response.data.data));
      })
      .catch((err) => {
        dispatch(getHomeTicketDetailsFaliure(err.message));
      });
  };
};

const deleteInprogessRequest = () => {
  return {
    type: DELETE_INPROGRESS_REQUEST,
  };
};

const deleteInprogessSuccess = (payload) => {
  return {
    type: DELETE_INPROGRESS_SUCCESS,
    payload: payload,
  };
};

const deleteInprogessFaliure = (error) => {
  return {
    type: DELETE_INPROGRESS_FAILURE,
    payload: error,
  };
};

const deleteInprogess = (ticketId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(deleteInprogessRequest());
    let url = `${baseUrl}/sp/ticket/delete_ticket?ticketId=${ticketId}`;
    return axios
      .delete(url, {}, headers)
      .then((response) => {
        dispatch(deleteInprogessSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(deleteInprogessFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const getStatusForInprogessRequest = () => {
  return {
    type: GET_STATUS_INPROGRESS_REQUEST,
  };
};

const getStatusForInprogessSuccess = (payload) => {
  return {
    type: GET_STATUS_INPROGRESS_SUCCESS,
    payload: payload,
  };
};

const getStatusForInprogessFailure = (error) => {
  return {
    type: GET_STATUS_INPROGRESS_FAILURE,
    payload: error,
  };
};

const getStatusForInprogess = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getStatusForInprogessRequest());
    let url = `${baseUrl}/sp/ticket/get_status`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getStatusForInprogessSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getStatusForInprogessFailure(err.message));
      });
  };
};

const InprogressTicketRequest = () => {
  return {
    type: UPDATE_INPROGRESS_REQUEST,
  };
};

const InprogressTicketSuccess = (payload) => {
  return {
    type: UPDATE_INPROGRESS_SUCCESS,
    payload: payload,
  };
};

const InprogressTicketFailure = (error) => {
  return {
    type: UPDATE_INPROGRESS_FAILURE,
    payload: error,
  };
};

const InprogressTicket = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(InprogressTicketRequest());
    let url = `${baseUrl}/sp/ticket/update_ticket?ticket`;
    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(InprogressTicketSuccess(response));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(InprogressTicketFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const CloseInprogressTicketRequest = () => {
  return {
    type: CLOSE_INPROGRESS_REQUEST,
  };
};

const CloseInprogressTicketSuccess = (payload) => {
  return {
    type: CLOSE_INPROGRESS_SUCCESS,
    payload: payload,
  };
};

const CloseInprogressTicketFailure = (error) => {
  return {
    type: CLOSE_INPROGRESS_FAILURE,
    payload: error,
  };
};

const CloseInprogressTicket = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(CloseInprogressTicketRequest());
    let url = `${baseUrl}/sp/ticket/close_ticket`;
    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(CloseInprogressTicketSuccess(response));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(CloseInprogressTicketFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

export {
  CloseInprogressTicket,
  InprogressTicket,
  addAttachments,
  addTicketComment,
  createTicket,
  deleteInprogess,
  getCompletedTickets,
  getHomeTicketDetails,
  getReportedTickets,
  getRequestTypes,
  getStatusForInprogess,
  getTicketComments,
  getTicketStatus,
  getTicketsByStatusForActive,
  getTicketsByStatusForCompleted,
  reopenTicket,
  ticketHomePage,
};
